import { render, staticRenderFns } from "./EditDancerComponent.vue?vue&type=template&id=44f65f20&scoped=true&"
import script from "./EditDancerComponent.vue?vue&type=script&lang=ts&"
export * from "./EditDancerComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f65f20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44f65f20')) {
      api.createRecord('44f65f20', component.options)
    } else {
      api.reload('44f65f20', component.options)
    }
    module.hot.accept("./EditDancerComponent.vue?vue&type=template&id=44f65f20&scoped=true&", function () {
      api.rerender('44f65f20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dancers/components/EditDancerComponent.vue"
export default component.exports